import Color from 'color';

export const getAnswerBackgroundColor = (poll, index) => {
  const answerColors = poll.jsStyle.answerColors;
  return answerColors[index % answerColors.length];
};

export const getAnswerColor = (poll, index) => {
  const backgroundColor = getAnswerBackgroundColor(poll, index);
  return Color(backgroundColor).isLight() ? '#000' : '#fff';
};
